import type { LocaleObject } from '@nuxtjs/i18n'

/**
 * qiYuCode的对应文档（可能不全，没有找到就写死en）：https://b.163.com/knowledge/public/WXjbs9n3GC/knowdetail?docId=X8GdkusvgW&pid=162306#de07e8a8
 * 七鱼后台对语言的设置：https://zsldywlkjyxgs2.servehub.aiconn.com/，账号：wangtian@changzhi.top 密码：Aa123456，如有变动，请咨询王田
 */
export const freezeLocales = [
  { code: 'tw', qiYuCode: 'zh-tw', file: 'zh_TW.json', iso: 'zh-tw', name: '繁體中文' },
  { code: 'en', qiYuCode: 'en', file: 'en_US.json', iso: 'x-default', name: 'English' },
  { code: 'fr', qiYuCode: 'fr', file: 'fr_FR.json', iso: 'fr', name: 'Français' },
  { code: 'ms', qiYuCode: 'en', file: 'ms_MY.json', iso: 'ms', name: 'Bahasa Melayu' },
  { code: 'de', qiYuCode: 'de', file: 'de_DE.json', iso: 'de', name: 'Deutsch' },
  { code: 'it', qiYuCode: 'en', file: 'it_IT.json', iso: 'it', name: 'Italiano' },
  { code: 'es', qiYuCode: 'es', file: 'es_ES.json', iso: 'es', name: 'Español' },
  { code: 'jp', qiYuCode: 'ja', file: 'ja_JP.json', iso: 'ja', name: '日本語' },
  { code: 'kr', qiYuCode: 'ko', file: 'ko_KR.json', iso: 'ko', name: '한국어' },
  { code: 'th', qiYuCode: 'th', file: 'th_TH.json', iso: 'th', name: 'ภาษาไทย' },
  { code: 'br', qiYuCode: 'pt', file: 'pt_PT.json', iso: 'pt-br', name: 'Português' },
  { code: 'id', qiYuCode: 'id', file: 'id_ID.json', iso: 'id', name: 'Bahasa Indonesia' },
  { code: 'vn', qiYuCode: 'vi', file: 'vi_VN.json', iso: 'vi', name: 'Tiếng Việt' },
  { code: 'ru', qiYuCode: 'ru', file: 'ru_RU.json', iso: 'ru', name: 'Pусский' },
  { code: 'tr', qiYuCode: 'en', file: 'tr_TR.json', iso: 'tr', name: 'Türkçe' },
  { code: 'sa', qiYuCode: 'en', file: 'ar_IL.json', iso: 'sa', name: 'العربية' },
] as const

/** 语言类型 */
export type Locale = (typeof freezeLocales)[number]['code'] | string

type FreezeLocalesMap = Record<Locale, LocaleObject>

export const freezeLocalesMap = freezeLocales.reduce((acc, data) => {
  acc[data.code] = data
  return acc
}, <FreezeLocalesMap>{})
